import React from 'react';

import { ForgeSelect } from '@tylertech/forge-react';

interface Option {
  label: string;
  value: string;
}

interface TableActionsSelectProps {
  options: Option[];
  placeHolder: string;
  value: string;
  label: string;
  onChange: (event: CustomEvent) => void;
  required?: boolean;
}

export const TableActionsSelect = ({
  options,
  label,
  placeHolder,
  onChange,
  value = '',
  required = false,
}: TableActionsSelectProps): JSX.Element => {
  const forgeSelectAttributes = {
    'data-testid': 'table-actions-column-selection',
    label: label,
    placeholder: placeHolder,
    onChange: onChange,
    floatLabelType: 'always',
    options,
    value,
    required: required,
  };

  return (
    <div className="authoring-field" key="actionColumnSelector">
      <div className="action-column-selector-container">
        <ForgeSelect {...forgeSelectAttributes} />
      </div>
    </div>
  );
};
